import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { PendingDashboardNavContext } from '../App';

/**
 * Campaign Manager Dashboard  
 * Interface for users who can create and manage SMS/email campaigns
 * Redirects to integrated ECM dashboard within SIMS
 */

export function CampaignManagerDashboard() {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem'
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '600px',
        background: 'var(--card-bg)',
        border: '1px solid var(--card-border)',
        borderRadius: '12px',
        padding: '3rem',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }}>
        <img 
          src="/images/Transparent full color logo.png" 
          alt="Laurus College Logo" 
          style={{ 
            width: '350px', 
            height: '350px', 
            marginBottom: '1rem',
            objectFit: 'contain'
          }} 
        />
        <h2 style={{ 
          margin: '0 0 1rem 0', 
          color: 'var(--accent)',
          fontSize: '28px'
        }}>
          Campaign Manager
        </h2>
        <p style={{ 
          color: 'var(--text-secondary)', 
          marginBottom: '2rem',
          fontSize: '16px',
          lineHeight: '1.6'
        }}>
          Access the integrated Campaign Dashboard to create and manage<br />
          <strong>SMS/Email campaigns</strong> within SIMS.
        </p>
        <button
          onClick={() => {
            const { setPendingDashboardNav } = useContext(PendingDashboardNavContext);
            setPendingDashboardNav(true);
            navigate('/ECM/Dashboard', { replace: true });
          }}
          disabled={false}
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            background: 'var(--accent)',
            color: 'var(--button-text)',
            textDecoration: 'none',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(255,215,0,0.3)',
            transition: 'all 0.3s',
            opacity: 1
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255,215,0,0.5)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255,215,0,0.3)';
          }}
        >
          📧 Campaign Dashboard
        </button>
        <p style={{
          color: 'var(--text-secondary)',
          marginTop: '1.5rem',
          fontSize: '14px'
        }}>
          Manage campaigns, view analytics, and create new messaging campaigns.
        </p>
      </div>
    </div>
  );
}
